import { SupportedLanguage } from '@common'
import { CookieSerializeOptions } from 'next/dist/server/web/spec-extension/cookies'

import { FeatureFlagsConfig } from '@/features/locale/configSlice'

export const NEXT_LOCALE = 'NEXT_LOCALE'
export const VIEWER_COUNTRY = 'VIEWER_COUNTRY'
export const STORE_FEATURES = 'STORE_FEATURES'

export const setLocaleCookie = (locale: SupportedLanguage) => {
  document.cookie = `NEXT_LOCALE=${locale}; expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/`
}

export const setStoreFeaturesCookies = (featureFlags: FeatureFlagsConfig) => {
  document.cookie = `STORE_FEATURES=${JSON.stringify(featureFlags)}; expires=Fri, 31 Dec 9999 23:59:59 GMT`
}

export const getCookie = (name: string) => {
  if (typeof document !== 'undefined') {
    const data = document.cookie
      .split(';')
      .map((pair) => pair.trim().split('='))
      .find(([key]) => key === name)
    if (!data) {
      return null
    }
    return data[1]
  }
  return null
}

export const deleteCookie = (cookie: string) => {
  document.cookie = `${cookie}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export const parseJsonCookie = <T>(cookie: string): T | undefined => {
  const value = getCookie(cookie)
  if (value) {
    return JSON.parse(value) as T
  }
}

export const cookieOptions: CookieSerializeOptions = {
  path: '/',
  maxAge: 31536000,
  sameSite: 'strict',
  secure: true,
} as const
